<template>
    <div class="clearfix">
        <compWrapper
            theme="primary"
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
        >
            <compFormEdit
                class="padding-top-15"
                ref="form"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <div v-if="querytype != 'query'" class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetBlackDetail,
    HttpUpdateBlackDetail,
    HttpGetCarrierGroupByCarrierId,
    HttpHostAndCustomerWarehouse,
    HttpOtherLogiServiceList,
    HttpBlackAccountLog
} from "@/service/carrieraccount.js";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            loading: false,
            formData: {},
            carrierGroupList: [],
            warehouseList: [],
            carrierServiceList: [],
            logList: []
        };
    },
    watch: {
        "formData.organizationId": {
            immediate: true,
            handler(organizationId) {
                if (!organizationId) return;
                HttpHostAndCustomerWarehouse({
                    contextId: global.SYSID,
                    orgId: organizationId,
                }).then(
                    (res) => {
                        this.warehouseList = res.data.map((item) => {
                            return {
                                value: item.id,
                                label: `${item.code}(${item.title})`,
                                attach: {
                                    ...item,
                                },
                            };
                        });
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            },
        },
        "formData.systemCarrierId": {
            immediate: true,
            handler(carrierId) {
                if (!carrierId) return;
                HttpGetCarrierGroupByCarrierId({
                    carrierId: carrierId,
                }).then(
                    (res) => {
                        this.carrierGroupList = res.data.map(
                            (item) => {
                                return {
                                    value: item.id,
                                    label: item.groupName,
                                };
                            },
                            (err) => {
                                this.$VMessage.error(err.message);
                            }
                        );
                    },
                    (err) => {}
                );
            },
        },
        "formData.carrierGroupId": {
            immediate: true,
            handler(carrierGroupId) {
                if (!carrierGroupId) return;
                HttpOtherLogiServiceList({
                    carrierGroupId: carrierGroupId,
                }).then(
                    (res) => {
                        this.carrierServiceList = res.data.map((item) => {
                            return {
                                value: item.id,
                                label:
                                    item.code +
                                    "(" +
                                    item.carrierServiceName +
                                    ")",
                            };
                        });
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            },
        },
    },
    created() {
        if (this.querytype !== "add") {
            this.getDetail();
            this.getLog();
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getSelfmanageorgList",
        ]),
        getBase() {
            return [
                {
                    label: this.$t("fbb.alloment.client_organization", {
                        defaultValue: "客户",
                    }),
                    key: "organizationId",
                    tag: "vSelect",
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query: this.querytype == 'query'
                },
                {
                    label: this.$t("global.common.warehouse", {
                        defaultValue: "仓库",
                    }),
                    key: "orgWarehouseId",
                    tag: "vSelect",
                    options: this.warehouseList,
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query: this.querytype == 'query'
                },
                {
                    label: this.$t("fbb.expresspackage.service_code", {
                        defaultValue: "承运商",
                    }),
                    key: "systemCarrierId",
                    tag: "vSelect",
                    options: this.getCarrierAllList.map((item) => {
                        return {
                            label: item.label,
                            value: item.attach.id,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query: this.querytype == 'query'
                },
                {
                    label: this.$t("fbb.carrieraccount.logistics_carrier", {
                        defaultValue: "物流商",
                    }),
                    key: "carrierGroupId",
                    tag: "vSelect",
                    options: this.carrierGroupList,
                    query: this.querytype == 'query'
                },
                {
                    label: this.$t("erp.b2c.hippingMethodCode", {
                        defaultValue: "物流服务",
                    }),
                    key: "systemCarrierServiceId",
                    tag: "vSelect",
                    options: this.carrierServiceList,
                    props: {
                        filterable: true,
                    },
                    required: true,
                    query: this.querytype == 'query'
                },
            ];
        },
    },
    methods: {
        async getLog () {
            await HttpBlackAccountLog({
                id: this.activeid
            }).then(res => {
                this.logList = res.data.orderLogList || [];
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async getDetail() {
            this.loading = true;
            await HttpGetBlackDetail({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            await HttpUpdateBlackDetail({
                id: this.activeid,
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>

<style>
</style>